import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';

const VerifyEmailPage = ({ showNotification }) => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('pending');

  useEffect(() => {
    const token = searchParams.get('token');
    const run = async () => {
      if (!token) { setStatus('error'); return; }
      try {
        const res = await axios.post('https://outiloeuvresvolees.inouiagency.com/api/auth/verify-email', { token });
        if (res.data && res.data.success) {
          setStatus('success');
          showNotification && showNotification('Email verified. You can log in now.', 'success');
        } else {
          setStatus('error');
          showNotification && showNotification(res.data.error || 'Verification failed', 'error');
        }
      } catch (e) {
        setStatus('error');
        showNotification && showNotification('Verification failed', 'error');
      }
    };
    run();
  }, [searchParams, showNotification]);

  return (
    <div className="max-w-md mx-auto bg-white rounded-xl shadow-sm border border-gray-200 p-6 text-center">
      {status === 'pending' && (
        <>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Verifying...</h1>
          <p className="text-gray-600">Please wait while we verify your email.</p>
        </>
      )}
      {status === 'success' && (
        <>
          <h1 className="text-2xl font-bold text-green-700 mb-2">Email Verified</h1>
          <p className="text-gray-600 mb-4">Your email has been verified successfully.</p>
          <Link to="/login" className="px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700">Go to Login</Link>
        </>
      )}
      {status === 'error' && (
        <>
          <h1 className="text-2xl font-bold text-red-700 mb-2">Verification Failed</h1>
          <p className="text-gray-600 mb-4">The verification link is invalid or expired.</p>
          <Link to="/login" className="px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700">Go to Login</Link>
        </>
      )}
    </div>
  );
};

export default VerifyEmailPage;



